/* 
  
  MF Simulator: Page Not Found
  
*/

import { Link } from 'react-router-dom';


const PageNotFound = (props) => {
  return (
    <div className={`container lang-${props.lan}`}>
      <div className="row d-flex align-items-center text-center vh-100">
        <div className="col">
          <img className="img-fluid" src="/img/error_404.svg" alt="404 Error" />
          <p className="not-found-text">We're sorry, but we're lost sight of that page!</p>
          <p className="not-found-text">Check the URL or return to the <Link to='/'>homepage</Link>.</p>
        </div>
      </div>
    </div>
  );
}

export default PageNotFound;
